import { render, staticRenderFns } from "./HeaderSidebar.vue?vue&type=template&id=505d6f7e&scoped=true"
import script from "./HeaderSidebar.js?vue&type=script&lang=js&external"
export * from "./HeaderSidebar.js?vue&type=script&lang=js&external"
import style0 from "./HeaderSidebar.scss?vue&type=style&index=0&id=505d6f7e&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "505d6f7e",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {HotIcon: require('/home/runner/_work/app-hotmart-legal/app-hotmart-legal/components/Atoms/Icon/Icon.vue').default,HotAnchor: require('/home/runner/_work/app-hotmart-legal/app-hotmart-legal/components/Molecules/Anchor/Anchor.vue').default,HotLink: require('/home/runner/_work/app-hotmart-legal/app-hotmart-legal/components/Atoms/HotLink/HotLink.vue').default,HotButton: require('/home/runner/_work/app-hotmart-legal/app-hotmart-legal/components/Molecules/Button/Button.vue').default})
